<template>
	<div class="welcome-screen">
		<AppHead title="OrthoMatrix" />

		<div class="grey-gradient" />

		<div class="logo">
			<img src="/images/logo-orthomatrix.svg" />
		</div>

		<div class="access-dashboard">
			<div v-if="canLogin">

				<div class="inner" v-if="$page.props.user">
					<Button 
						v-if="$page.props.user.user_type == 'admin'"
						buttonRoute="cases"
						label="Open Document Room"
						size="regular"
						color="dark"
						icon="chevron-double-right"
						/>
					<Button 
						v-else
						buttonRoute="cases"
						label="Open Document Room"
						size="regular"
						color="dark"
						icon="chevron-double-right"
						/>
				</div>

				<div class="inner" v-else>
					<Button 
						buttonRoute="login"
						label="Log in"
						size="regular"
						color="dark"
						icon="sign-in"
						class="button"
						/>

					<Button
						v-if="canRegister"
						buttonRoute="register"
						label="Register"
						size="regular"
						color="green"
						icon="user"
						class="button"
						/>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { Head, Link } from '@inertiajs/inertia-vue3'
	import AppHead from "@/Components/AppHead"
	import Button from "@/Components/Button"

	export default {
		components: {
			AppHead,
			Link,
			Button
		},

		props: {
			canLogin: Boolean,
			canRegister: Boolean
		}
	}
</script>

<style lang="sass" scoped>

.welcome-screen
	width: 100vw
	height: 100vh
	display: flex
	align-items: center
	justify-content: center
	flex-direction: column

	.grey-gradient
		position: absolute
		top: 0
		left: 0
		right: 0
		height: 80vh
		background: linear-gradient(rgba(#E1E5E8, 1), rgba(#E1E5E8, 0))
		
	.access-dashboard
		z-index: 9
		width: 100%
		position: relative

		.inner
			display: flex
			align-items: center
			justify-content: center
		
		.button
			margin: 0 10px

	.logo
		margin-bottom: 40px
		z-index: 9
		position: relative

		img
			width: 290px
			height: auto

</style>